/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type DefectSeverity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type Defect_status = "ACCEPTED" | "IDENTIFIED" | "IN_REVIEW" | "REJECTED" | "RESOLVED" | "%future added value";
export type Severity = "CRITICAL" | "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type CreateDefectInput = {
    inspectionId: string;
    title: string;
    description?: string | null;
    severity?: DefectSeverity | null;
    roomType?: string | null;
    defectCategory?: string | null;
    sourceClipIndex?: number | null;
    sourceFramePosition?: string | null;
    evidenceImageUri?: string | null;
};
export type InspectionPanelCreateDefectMutationVariables = {
    input: CreateDefectInput;
};
export type InspectionPanelCreateDefectMutationResponse = {
    readonly createDefect: {
        readonly defect: {
            readonly id: string;
            readonly title: string;
            readonly description: string;
            readonly severity: Severity;
            readonly defectStatus: Defect_status;
            readonly roomType: string;
            readonly defectCategory: string;
            readonly sourceClipIndex: number;
            readonly sourceFramePosition: string;
            readonly aiDetected: boolean;
            readonly aiConfidence: number;
            readonly evidenceImageURI: string;
            readonly audioStartSeconds: number;
            readonly audioEndSeconds: number;
        };
    };
};
export type InspectionPanelCreateDefectMutation = {
    readonly response: InspectionPanelCreateDefectMutationResponse;
    readonly variables: InspectionPanelCreateDefectMutationVariables;
};



/*
mutation InspectionPanelCreateDefectMutation(
  $input: CreateDefectInput!
) {
  createDefect(input: $input) {
    defect {
      id
      title
      description
      severity
      defectStatus
      roomType
      defectCategory
      sourceClipIndex
      sourceFramePosition
      aiDetected
      aiConfidence
      evidenceImageURI
      audioStartSeconds
      audioEndSeconds
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateDefectPayload",
    "kind": "LinkedField",
    "name": "createDefect",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DefectItem",
        "kind": "LinkedField",
        "name": "defect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "severity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defectStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roomType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "defectCategory",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceClipIndex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceFramePosition",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiDetected",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiConfidence",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "evidenceImageURI",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "audioStartSeconds",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "audioEndSeconds",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionPanelCreateDefectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionPanelCreateDefectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3f4da16cbee827e6eb3e6b912f6cc9a6",
    "id": null,
    "metadata": {},
    "name": "InspectionPanelCreateDefectMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionPanelCreateDefectMutation(\n  $input: CreateDefectInput!\n) {\n  createDefect(input: $input) {\n    defect {\n      id\n      title\n      description\n      severity\n      defectStatus\n      roomType\n      defectCategory\n      sourceClipIndex\n      sourceFramePosition\n      aiDetected\n      aiConfidence\n      evidenceImageURI\n      audioStartSeconds\n      audioEndSeconds\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '1520d564be6d6d717b89b410300afb9e';
export default node;
